import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../constants/common'
import { usePageBrowserTabTitle } from '../../hooks'
import { NotificationInline } from '../Notification'
import { Page } from '../Page'
import { PageHeader } from '../PageHeader'

import {
  QA_NAME_CALENDAR_SETTINGS,
  QA_NAME_CALENDAR_SETTINGS_LOAD_ERROR,
} from './CalendarSettings.constants'
import { useCalendarSettingsData } from './CalendarSettings.hooks'
import {
  CalendarSettingsForm,
  CalendarSettingsFormSkeleton,
} from './CalendarSettingsForm'

function CalendarSettings() {
  const { t } = useTranslation()

  const { handleSaveSettings, isLoading, serverError, settings } =
    useCalendarSettingsData()

  usePageBrowserTabTitle({
    isLoading,
    pageTitle: t('BrowserTab.CalendarSettingsPageTitleKey'),
  })

  return (
    <Page qaName={QA_NAME_CALENDAR_SETTINGS}>
      <PageHeader title={t('CalendarSettings.PageTitleKey')} />
      {isLoading ? (
        <CalendarSettingsFormSkeleton />
      ) : serverError ? (
        <NotificationInline
          qaName={QA_NAME_CALENDAR_SETTINGS_LOAD_ERROR}
          text={t('Error.CommonApiRequestFailKey')}
          type={NOTIFICATION_TYPE.error}
        />
      ) : (
        <CalendarSettingsForm settings={settings} onSave={handleSaveSettings} />
      )}
    </Page>
  )
}

export default CalendarSettings
